import {Case} from '../../../beans/Case';
import {Nomenclature} from '../../../beans/Nomenclature';
import {FrxBaseBean} from '../../../beans/frxbasebean';
import {Izpulnitelno} from '../../../beans/izpulnitelno';
import {WordTemplate} from '../../../beans/word-template';
import {BlockUiService} from '../../../services/blockui.service';
import {CaseService} from '../../../services/case.service';
import {NomenclatureService} from '../../../services/nomenclature.service';
import {WordTemplateService} from '../../../services/word-template.service';
import {EditCaseComponent} from '../edit-case.component';
import {Component, OnInit, Input, ViewContainerRef, Host} from '@angular/core';

@Component({
	selector: 'app-edit-case-izpulnitelno',
	templateUrl: './edit-case-izpulnitelno.component.html',
	styleUrls: ['./edit-case-izpulnitelno.component.scss']
})
export class EditCaseIzpulnitelnoComponent implements OnInit {

	private _izpultenoDelo: Izpulnitelno;
	private _caseid;


	chsis: Array<Nomenclature>;
	statuses: Array<Nomenclature>;

	// Word templates
	izpTemplates: WordTemplate[] = [];
	selectedIzpTemplate: WordTemplate = null;

	constructor(
		private caseService: CaseService,
		private damageService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private wordTemplateService: WordTemplateService,
		@Host() private parentComp: EditCaseComponent ) {}

	ngOnInit() {
		this.loadNomenclatures();
		this.loadIzpTemplates();
	}

	private loadIzpTemplates() {
		this.wordTemplateService.findByType('IZPULNITELNO').subscribe(
			data => this.izpTemplates = data,
			err => { }
		);
	}

	generateDocument() {
		if (!this.selectedIzpTemplate || !this._caseid) return;
		this.blockUi.start(this.vcRef);
		this.wordTemplateService.generateDocument(this.selectedIzpTemplate.id, this._caseid).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = this.selectedIzpTemplate.name + '_generated.docx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				alert('Грешка при генериране на документ');
			}
		);
	}


	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}

	public get izpulnitelnoDelo() {
		return this._izpultenoDelo;
	}

	private refresh() {
		this._izpultenoDelo = new Izpulnitelno();
	}

	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
			if (caseObj.izpulnitelnoDelo && caseObj.izpulnitelnoDelo.id) {
				this._izpultenoDelo.copy(caseObj.izpulnitelnoDelo);
			}
		}
	}

	private loadNomenclatures() {
		this.loadChsi();
		this.loadStatuses();
	}

	private loadChsi() {
		this.blockUi.start(this.vcRef);
		this.chsis = new Array<Nomenclature>();
		this.damageService.getChsi().subscribe(types => {
			this.chsis = types;
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	private loadStatuses() {
		this.blockUi.start(this.vcRef);
		this.statuses = new Array<Nomenclature>();
		this.damageService.getStatusIzpulnitelno().subscribe(types => {
			this.statuses = types;
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	// TODO: This should be in a separate service.. not copy-pasted in each component.... too lazy, don't care
	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}

	public save() {
		this.blockUi.start(this.vcRef);
		this.caseService.saveIzpalnitelno(this._izpultenoDelo, this._caseid).subscribe(
			result => {
				this.blockUi.stop();
				alert('Данните за Изпълнителното Дело бяха записани');
				this.parentComp.reload();
			},
			error => {
				alert('Възникна Грешка');
				this.blockUi.stop();
			});
	}

}
